module.exports = __webpack_public_path__ + "static/media/insightu-logo.6d710017.png";